import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
  editButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "normal",
    fontWeight: "bold",
    height: "40px",
    fontSize: "0.75rem",
    padding: "5px 15px",
    marginRight: "5px",
    marginBottom: "13px",
    marginTop: "0px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  editButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "normal",
    fontWeight: "bold",
    height: "40px",
    fontSize: "0.75rem",
    padding: "5px 15px",
    marginRight: "5px",
    marginBottom: "13px",
    marginTop: "0px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
}));

export default function EditButton(props) {
  const { buttonDisabled, handleSubmit, children } = props;

  const classes = useStyles();

  return (
    <Button
      disabled={buttonDisabled}
      className={
        buttonDisabled ? classes.editButtonDisabled : classes.editButton
      }
      onClick={() => {
        handleSubmit();
      }}
    >
      {children}
    </Button>
  );
}

EditButton.propTypes = {
  inputTitle: PropTypes.any,
};
